/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - 認識新朋友，聊天，社交",
      "電話號碼不正確",
      "Get the app",
      "用Apple繼續",
      "用Facebook繼續",
      "用Google繼續",
      "登入",
      "註冊",
      "請輸入以下符號",
      "繼續",
      "輸入符號",
      "安全檢查",
      "重新加載",
      "創建容易記住的新密碼",
      "更新",
      "確認密碼",
      "密碼必須至少{{num}}個[[characters:num]]",
      "密碼",
      "創建新密碼",
      "Badoo - 博客",
      "工作機會",
      "聊天",
      "城市",
      "管理cookies",
      "版權所有 © 2006 – 至今。Bumble保留所有版權",
      "Apple和Apple標誌是Apple Inc.的商標。{{__EOL__}}Google Play標誌是Google LLC.的商標",
      "下載",
      "Facebook",
      "追蹤我們",
      "幫助中心",
      "Instagram",
      "語言",
      "LinkedIn",
      "概述",
      "Badoo屬於Bumble Inc",
      "隱私政策",
      "安全中心",
      "網站導覽",
      "現代奴役法案聲明",
      "條款和細則",
      "Twitter",
      "請鍵入您的電郵或手機號，如何創建新密碼的指引會隨後送達",
      "取得新密碼",
      "輸入電郵或手機號",
      "忘記密碼",
      "模特相片僅用於範例",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "無需等待配對{{__EOL__}}{{__EOL__}}您可以直接開啟聊天，深層對話，了解彼此",
      "準備聊天？",
      "繼續註冊，表示您同意 <a class=\"link\" href=\"{{terms_url}}\">“條款和細則”</a>。了解更多請前往 <a class=\"link\" href=\"{{privacy_url}}\">“隱私政策”</a>",
      "幫助您展示真實的自己，<br />體驗快樂交友",
      "自信約會",
      "或者",
      "已有賬號？",
      "使用電郵或手機號註冊",
      "表明約會目的{{__EOL__}}無需道歉",
      "只想聊天？沒問題{{__EOL__}}準備穩定下來？沒問題{{__EOL__}}{{__EOL__}}如果改變主意，您可以隨時更新",
      "約會",
      "戀愛",
      "聊天",
      "遇見志同道合的人",
      "{{name}}，{{age}}歲",
      "我們旨在維護您的安全",
      "“安全中心”是知識寶庫，包含了您自信約會所需的支持",
      "前往“安全中心”",
      "安全<br/>永遠第一",
      "從一開始我就以為會有結果…",
      "我以前沒打算認真的...",
      "使用Badoo APP最佳方式就是，展示真實的自己...",
      "Badoo成功案例",
      "查看更多成功案例",
      "{{num}}__CUT__評分",
      "Apple App Store",
      "請相信，自2006年以來，我們已有數百萬（以及數百萬，數百萬）的人，找到合適人選",
      "{{num}}百萬+__CUT__下載",
      "{{num}}百萬+",
      "Google Play Store",
      "我們經驗豐富",
      "使用電郵或手機號登入",
      "輸入密碼",
      "忘記密碼？",
      "註冊",
      "沒有賬號？",
      "登入",
      "註冊"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "字元"
            ],
            "singular": [
                  "字元"
            ]
      },
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
